/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_QualifiedInputs */

const cs_enum_qualified = /** @type {(inputs: Enum_QualifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kvalifikován`)
};

const en_enum_qualified = /** @type {(inputs: Enum_QualifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualified`)
};

/**
* | output |
* | --- |
* | "Qualified" |
*
* @param {Enum_QualifiedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_qualified = /** @type {((inputs?: Enum_QualifiedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_QualifiedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_qualified(inputs)
	return cs_enum_qualified(inputs)
});